export const CONTACT_EMAIL = 'ask@scrambleup.com';
export const CONTACT_PHONE = '+372 712 2955';
export const EMPTY_DASH = '—';

export const PRODUCT_ID = {
  claims: 'claims',
  crowdfunding: 'crowdfunding',
} as const;